import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { getSearchParamsFilters } from 'hb-react/frontoffice/apps/Filters/form/getInitialValues';

export const useEventsFilters = () => {
  const [params] = useSearchParams();

  // These two values must be set at the same time to avoid calling
  // the backend with an empty query when clearing all the existing filters.
  // Otherwise we get the following scenarios (depending on which order you update the two props):
  // 1) filters.query: something, totalSelectedMoreFilters: 1
  // 2) User clears the filers
  // 3) filters.query: cleared, totalSelectedMoreFilters: 1 --> 'Events" group rendered with empty query for no reason
  // 4) filters.query: cleared, totalSelectedMoreFilters: 0 --> Other groups rendered as expected
  // OR
  // 1) filters.query: cleared, totalSelectedMoreFilters: 0
  // 2) User applies a filter
  // 3) filters.query: cleared, totalSelectedMoreFilters: 1 --> 'Events" group rendered with empty query for no reason
  // 4) filters.query: something, totalSelectedMoreFilters: 1 --> 'Events" group rendered with filters as expected
  const filters = getSearchParamsFilters(Object.fromEntries(params));
  const initialState = {
    filters: {
      query: filters,
    },
    totalSelectedMoreFilters: Object.keys(filters).length,
  };

  return useState<{
    filters: any;
    totalSelectedMoreFilters: number;
  }>(initialState);
};
